import { useState } from 'react';
import ContentLayout from '@cloudscape-design/components/content-layout';
import Header from '@cloudscape-design/components/header';
import SpaceBetween from '@cloudscape-design/components/space-between';
import Tabs from '@cloudscape-design/components/tabs';
import { MailEmlAnalyzerTab } from '@components/MailEmlAnalyzerTab';
import { AboutMailEmlAnalyzerTab } from '@components/AboutMailEmlAnalyzerTab';

const MailEmlAnalyzerTool = () => {
  const [activeTabId, setActiveTabId] = useState('analyzer');

  return (
    <ContentLayout
      header={
      <Header
        variant="h1"
        description="Upload and comprehensively analyze email files in EML format. Includes header analysis, authentication checks, and invisible character detection."
      >
        Check EMail EML File on invisible Characters
      </Header>
      }
    >
      <SpaceBetween size="l">
        <Tabs
          activeTabId={activeTabId}
          onChange={({ detail }) => setActiveTabId(detail.activeTabId)}
          tabs={[
            {
              id: 'analyzer',
              label: 'Analyze Email EML-File',
              content: <MailEmlAnalyzerTab />,
            },
            {
              id: 'about',
              label: 'About Analyze Email EML-File',
              content: <AboutMailEmlAnalyzerTab />,
            },
          ]}
        />
      </SpaceBetween>
    </ContentLayout>
  );
};

export default MailEmlAnalyzerTool;

